import { activityTypes } from '../constants/activityTypes';
export function safeParseJSON(json, defaultValue) {
  if (!json) {
    return defaultValue;
  }
  try {
    return JSON.parse(json);
  } catch (_unused) {
    return defaultValue;
  }
}
export function parseActivityTarget(activityTarget) {
  return {
    assetType: activityTarget.objectKey.objectTypeId,
    assetId: activityTarget.objectKey.objectId,
    assetName: activityTarget.name
  };
}
export function parseActivityComment(activityDetails) {
  if (!activityDetails) {
    return undefined;
  }
  return activityDetails.reduce((prev, current) => {
    switch (current.propertyName) {
      default:
        return prev;
      case 'manual_comment_message':
        return Object.assign({}, prev, {
          value: current.newValue
        });
      case 'manual_comment_id':
        return Object.assign({}, prev, {
          commentId: parseInt(current.newValue, 10)
        });
      case 'manual_comment_is_reply':
        return Object.assign({}, prev, {
          isReply: String(current.newValue).toLowerCase() === 'true'
        });
      case 'manual_comment_reply_parent_id':
        return Object.assign({}, prev, {
          replyParentId: parseInt(current.newValue, 10)
        });
      case 'manual_comment_object_id':
        return Object.assign({}, prev, {
          commentObjectId: current.newValue
        });
    }
  }, {});
}
export function isContentEditEvent(activityDetails) {
  return Boolean(activityDetails && activityDetails.some(detail => detail.propertyName === 'manual_content_id' || detail.propertyName === 'manual_version_id'));
}

/**
 * For content edit events we should not take into account the details sent by the BE.
 * It contains unwanted data that we don't want to show users. Slack: https://hubspot.slack.com/archives/C03AAJD37BL/p1712925857224819?thread_ts=1712311667.727379&cid=C03AAJD37BL
 */
export function parseActivityUpdateDetails({
  activityType,
  activityDetails
}) {
  return [activityTypes.UPDATED, activityTypes.RENAMED].includes(activityType) && activityDetails && !isContentEditEvent(activityDetails) ? activityDetails : [];
}
export function parseApprovalNote(activityDetails) {
  var _activityDetails$find;
  if (!activityDetails) {
    return undefined;
  }
  return (_activityDetails$find = activityDetails.find(detail => detail.propertyName === 'hs_note')) === null || _activityDetails$find === void 0 ? void 0 : _activityDetails$find.newValue;
}